export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  'aria-label': string;
}

export function Switch({ checked, onChange, disabled, 'aria-label': ariaLabel }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      className="au-switch"
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <span className="au-switch__thumb" aria-hidden />
    </button>
  );
}
